import {Component, forwardRef, Injector} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {AbstractSingleSelectEditControlComponent} from "../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";

const CUSTOM_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => DayOfMonthSingleSelectEditControlComponent),
    multi: true
};

@Component({
    selector: "wbo-day-of-month-single-select-edit-control",
    templateUrl: "../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [
        CUSTOM_VALUE_ACCESSOR
    ]
})
export class DayOfMonthSingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<any> {
    constructor(injector: Injector) {
        super(undefined, injector);
        this.buildData(Array.from({length: 31}, (x, i) => i + 1).map(day => {
            return {label: "'" + day + "'", value: day};
        }));
    }
}
